export default "__VITE_ASSET__a41YaNJD__"